// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.HomeFeature_home-feature__LLcy5 {
  display: flex;
  padding: 80px 24px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 48px;
  align-self: stretch;
  background: var(--background-color-1);
}
.HomeFeature_home-feature__LLcy5 .HomeFeature_home-feature__container__gd7cC {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 32px;
  align-self: stretch;
}
.HomeFeature_home-feature__LLcy5 .HomeFeature_home-feature__container--title__DcbFs {
  color: var(--accent-color);
  font-size: 52px;
  font-weight: 700;
  text-align: center;
}
.HomeFeature_home-feature__LLcy5 .HomeFeature_home-feature__container--content__O0zUq {
  display: flex;
  align-items: center;
  gap: 32px;
  align-self: stretch;
}
.HomeFeature_home-feature__LLcy5 .HomeFeature_home-feature__container--content__left__mZQUB {
  flex: 4 1;
  aspect-ratio: 718/464;
  align-self: stretch;
  position: relative;
  margin-bottom: -60px;
}
.HomeFeature_home-feature__LLcy5 .HomeFeature_home-feature__container--content__left--image__mcHoY {
  height: 100%;
  object-fit: cover;
}
.HomeFeature_home-feature__LLcy5 .HomeFeature_home-feature__container--content__left--image__container__Ay5DR {
  height: 100%;
  left: 0;
  overflow: hidden;
  position: absolute;
  top: 0;
  width: 100%;
}
.HomeFeature_home-feature__LLcy5 .HomeFeature_home-feature__container--content__right__bJXjd {
  flex: 3 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 32px;
}
.HomeFeature_home-feature__LLcy5 .HomeFeature_home-feature__container--content__right--title__jcp0m {
  color: var(--accent-color);
  font-size: 32px;
}
.HomeFeature_home-feature__LLcy5 .HomeFeature_home-feature__container--content__right--description__VJ75H {
  color: var(--text-1);
  font-weight: 500;
}
.HomeFeature_home-feature__LLcy5 .HomeFeature_home-feature__container--content__right--highlight__mXEcL {
  font-weight: 600;
  text-decoration: none;
  color: var(--accent-color);
}
.HomeFeature_home-feature__LLcy5 .HomeFeature_home-feature__container--content__right--highlight__mXEcL:hover {
  cursor: pointer;
  text-decoration: underline;
}
.HomeFeature_home-feature__LLcy5 .HomeFeature_home-feature__container--content__right--highlight__container__71Ivc {
  color: var(--text-1);
}
@media only screen and (max-width: 480px) {
  .HomeFeature_home-feature__LLcy5 .HomeFeature_home-feature__container--title__DcbFs {
    font-size: 32px;
  }
  .HomeFeature_home-feature__LLcy5 .HomeFeature_home-feature__container--content__O0zUq {
    flex-direction: column;
  }
  .HomeFeature_home-feature__LLcy5 .HomeFeature_home-feature__container--content__left__mZQUB {
    margin-bottom: 0px;
  }
  .HomeFeature_home-feature__LLcy5 .HomeFeature_home-feature__container--content__right--title__jcp0m {
    font-size: 24px;
  }
  .HomeFeature_home-feature__LLcy5 .HomeFeature_home-feature__container--content__right--description__VJ75H {
    font-size: 14px;
    text-align: justify;
  }
  .HomeFeature_home-feature__LLcy5 .HomeFeature_home-feature__container--content__right--highlight__container__71Ivc {
    font-size: 14px;
  }
}`, "",{"version":3,"sources":["webpack://./src/Explore/Pages/Home/Components/HomeFeature/HomeFeature.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,kBAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;EACA,qCAAA;AACF;AAEI;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;AAAN;AAEM;EACE,0BAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AAAR;AAGM;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;AADR;AAGQ;EACE,SAAA;EACA,qBAAA;EACA,mBAAA;EACA,kBAAA;EACA,oBAAA;AADV;AAGU;EACE,YAAA;EACA,iBAAA;AADZ;AAGY;EACE,YAAA;EACA,OAAA;EACA,gBAAA;EACA,kBAAA;EACA,MAAA;EACA,WAAA;AADd;AAKQ;EACE,SAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,uBAAA;EACA,SAAA;AAHV;AAKU;EACE,0BAAA;EACA,eAAA;AAHZ;AAMU;EACE,oBAAA;EACA,gBAAA;AAJZ;AAOU;EACE,gBAAA;EACA,qBAAA;EACA,0BAAA;AALZ;AAMY;EACE,eAAA;EACA,0BAAA;AAJd;AAMY;EACE,oBAAA;AAJd;AAYE;EAGM;IACE,eAAA;EAZR;EAcM;IACE,sBAAA;EAZR;EAaQ;IACE,kBAAA;EAXV;EAcU;IACE,eAAA;EAZZ;EAcU;IACE,eAAA;IACA,mBAAA;EAZZ;EAeY;IACE,eAAA;EAbd;AACF","sourcesContent":[".home-feature {\n  display: flex;\n  padding: 80px 24px;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 48px;\n  align-self: stretch;\n  background: var(--background-color-1);\n\n  .home-feature {\n    &__container {\n      display: flex;\n      flex-direction: column;\n      justify-content: center;\n      align-items: center;\n      gap: 32px;\n      align-self: stretch;\n\n      &--title {\n        color: var(--accent-color);\n        font-size: 52px;\n        font-weight: 700;\n        text-align: center;\n      }\n\n      &--content {\n        display: flex;\n        align-items: center;\n        gap: 32px;\n        align-self: stretch;\n\n        &__left {\n          flex: 4;\n          aspect-ratio: 718 / 464;\n          align-self: stretch;\n          position: relative;\n          margin-bottom: -60px;\n\n          &--image {\n            height: 100%;\n            object-fit: cover;\n\n            &__container {\n              height: 100%;\n              left: 0;\n              overflow: hidden;\n              position: absolute;\n              top: 0;\n              width: 100%;\n            }\n          }\n        }\n        &__right {\n          flex: 3;\n          display: flex;\n          flex-direction: column;\n          justify-content: center;\n          align-items: flex-start;\n          gap: 32px;\n\n          &--title {\n            color: var(--accent-color);\n            font-size: 32px;\n          }\n\n          &--description {\n            color: var(--text-1);\n            font-weight: 500;\n          }\n\n          &--highlight {\n            font-weight: 600;\n            text-decoration: none;\n            color: var(--accent-color);\n            &:hover {\n              cursor: pointer;\n              text-decoration: underline;\n            }\n            &__container {\n              color: var(--text-1);\n            }\n          }\n        }\n      }\n    }\n  }\n\n  @media only screen and (max-width: 480px) {\n    .home-feature {\n      &__container {\n        &--title {\n          font-size: 32px;\n        }\n        &--content {\n          flex-direction: column;\n          &__left {\n            margin-bottom: 0px;\n          }\n          &__right {\n            &--title {\n              font-size: 24px;\n            }\n            &--description {\n              font-size: 14px;\n              text-align: justify;\n            }\n            &--highlight {\n              &__container {\n                font-size: 14px;\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"home-feature": `HomeFeature_home-feature__LLcy5`,
	"home-feature__container": `HomeFeature_home-feature__container__gd7cC`,
	"home-feature__container--title": `HomeFeature_home-feature__container--title__DcbFs`,
	"home-feature__container--content": `HomeFeature_home-feature__container--content__O0zUq`,
	"home-feature__container--content__left": `HomeFeature_home-feature__container--content__left__mZQUB`,
	"home-feature__container--content__left--image": `HomeFeature_home-feature__container--content__left--image__mcHoY`,
	"home-feature__container--content__left--image__container": `HomeFeature_home-feature__container--content__left--image__container__Ay5DR`,
	"home-feature__container--content__right": `HomeFeature_home-feature__container--content__right__bJXjd`,
	"home-feature__container--content__right--title": `HomeFeature_home-feature__container--content__right--title__jcp0m`,
	"home-feature__container--content__right--description": `HomeFeature_home-feature__container--content__right--description__VJ75H`,
	"home-feature__container--content__right--highlight": `HomeFeature_home-feature__container--content__right--highlight__mXEcL`,
	"home-feature__container--content__right--highlight__container": `HomeFeature_home-feature__container--content__right--highlight__container__71Ivc`
};
export default ___CSS_LOADER_EXPORT___;
